const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        titleLabel: cc.Label,
        message: cc.Label,
        closeButton: cc.Button,
        content: cc.Node,
        buttonsContainer: cc.Node,
        globalBlocker: cc.Node,
        buttonNodes: [cc.Node],
    },

    onDisable () {
        this.globalBlocker.active = false;
    },

    onButtonClick (data) {
        const index = this.buttonNodes.indexOf(data.currentTarget);

        if (this.buttonNodes[index].handler) {
            this.buttonNodes[index].handler();
        }
    },

    open ({ title, message, closeEnabled = true, buttons, titleOption, messageOption }) {
        this.globalBlocker.active = true;
        this.closeEnabled = closeEnabled;
        if (title) {
            this.titleLabel.string = i18n.t(title, titleOption);
            this.titleLabel.node.active = true;
        } else {
            this.titleLabel.string = '';
            this.titleLabel.node.active = false;
        }
        
        if (message) {
            this.message.string = i18n.t(message, messageOption);
            this.message.node.active = true;
        } else {
            this.titleLabel.string = '';
            this.message.node.active = false;
        }

        this.buttonsContainer.active = this.closeEnabled || buttons;
        this.closeButton.node.active = this.closeEnabled;
        this.buttonNodes.forEach(node => {
            node.active = false;
            node.handler = null;
        });

        if (buttons) {
            for (let i = 0; i < buttons.length; i++) {
                const { title, handler } = buttons[i];
    
                const buttonNode = this.buttonNodes[i];
                buttonNode.active = true;
                buttonNode.handler = handler;
                buttonNode.children[0].children[0].getComponent(cc.Label).textKey = title;
            }
        }

        this.node.active = true;
        this.node.children[0].getComponent(cc.Layout).updateLayout();
    },

});
